export const greyA100 = '#f4f5f6';

export const grey50 = '#eceff1';
export const grey100 = '#cfd8dc';
export const grey200 = '#b0bec5';
export const grey300 = '#90a4ae';
export const grey400 = '#78909c';
export const grey500 = '#607d8b';
export const grey600 = '#546e7a';
export const grey700 = '#455a64';
export const grey800 = '#37474f';
export const grey900 = '#263238';

export const indigo900 = '#1a237e';

export const blue100 = '#bbdefb';
export const blue300 = '#64b5f6';
export const blue500 = '#2196f3';
export const blue600 = '#1e88e5';
export const blue700 = '#1976d2';
export const blue800 = '#1565c0';
export const blue900 = '#0d47a1';

export const lightBlue100 = '#b3e5fc';
export const lightBlue900 = '#01579b';

export const green50 = '#f1f8e9';
export const green100 = '#dcedc8';
export const green600 = '#7cb342';
export const green700 = '#598230';
export const green800 = '#33691e';

export const yellow100 = '#fff9c4';
export const yellow600 = '#fdd835';
export const yellow800 = '#ffd200';

export const orange500 = '#ff9800';
export const orange700 = '#f57c00';

export const red100 = '#CD6D52';
export const red200 = '#BB4C33';
export const red300 = '#993300';
export const red400 = '#8E290A';
export const red500 = '#b71c1c';

export const black = '#000000';
export const white = '#ffffff';

export const transparent = 'rgba(0, 0, 0, 0)';
export const fullBlack = 'rgba(0, 0, 0, 1)';
export const darkBlack = 'rgba(0, 0, 0, 0.87)';
export const lightBlack = 'rgba(0, 0, 0, 0.54)';
export const minBlack = 'rgba(0, 0, 0, 0.26)';
export const faintBlack = 'rgba(0, 0, 0, 0.12)';
export const fullWhite = 'rgba(255, 255, 255, 1)';
export const darkWhite = 'rgba(255, 255, 255, 0.87)';
export const lightWhite = 'rgba(255, 255, 255, 0.54)';
